<mat-card class="new-key-system-dialog">
  <!-- Header -->
  <mat-card-header class="header-container">
    <mat-card-title>Create New Independent System</mat-card-title>
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <mat-divider></mat-divider>

  <!-- Content -->
  <mat-card-content>
      <div class="d-height">
        <!-- New Structure -->
        <form [formGroup]="newStructureForm" autocompete="off" (keyup.enter)="createStructure()">
          <div class="section">
            <h6 class="section-header margin bottom">Key System</h6>
            <!-- Keyway Family -->
            <div class="row">
              <mat-form-field floatLabel="always" appearance="outline" class="margin sm right half-width">
                  <mat-label
                    for="country"
                    [ngClass]="{
                      'error-message': fieldHasError(newStructureForm, 'keywayFamily'),
                      focus: focus.keywayFamily
                    }"
                  >
                    Keyway family
                  </mat-label>

                <mat-select
                  [ngClass]="{
                    error: fieldHasError(newStructureForm, 'keywayFamily'),
                    disabled: true,
                    'focus-border': focus.keywayFamily
                  }"
                  matNativeControl
                  formControlName="keywayFamily"
                  [(value)]="selectedKeywayFamily"
                >
                  <mat-option *ngFor="let keywayFamily of keywayFamilies" [value]="keywayFamily">
                    {{ keywayFamily.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Combinating Rule Set -->
              <mat-form-field floatLabel="always" appearance="outline" class="margin sm left half-width">
                  <mat-label
                    for="combinatingRuleSet"
                    [ngClass]="{
                      'error-message': fieldHasError(newStructureForm, 'combinatingRuleSet'),
                      focus: focus.combinatingRuleSet
                    }"
                  >
                    Combinating Rule Set
                  </mat-label>

                <mat-select
                  [ngClass]="{
                    error: fieldHasError(newStructureForm, 'combinatingRuleSet'),
                    disabled: true,
                    'focus-border': focus.combinatingRuleSet
                  }"
                  matNativeControl
                  formControlName="combinatingRuleSet"
                >
                  <mat-option *ngFor="let combinatingRuleSet of combinatingRuleSets" [value]="combinatingRuleSet">
                    {{ combinatingRuleSet.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="row">
              <!-- Chamber Type -->
              <mat-form-field floatLabel="always" appearance="outline" class="margin sm right half-width">
                  <mat-label
                    for="chamberType"
                    [ngClass]="{
                      'error-message': fieldHasError(newStructureForm, 'chamberType'),
                      focus: focus.combinatingRuleSet
                    }"
                  >
                    Chamber Type
                  </mat-label>

                <mat-select
                  [ngClass]="{
                    error: fieldHasError(newStructureForm, 'chamberType'),
                    disabled: true,
                    'focus-border': focus.chamberType
                  }"
                  matNativeControl
                  formControlName="chamberType"
                  [(value)]="selectedChamberType"
                  [compareWith]="compareObjs"
                >
                  <mat-option *ngFor="let chamberType of chamberTypes" [value]="chamberType">
                    {{ chamberType.description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Construction Key Type -->
              <mat-form-field floatLabel="always" appearance="outline" class="margin sm left half-width">
                  <mat-label
                    for="constructionKeyType"
                    [ngClass]="{
                      'error-message': fieldHasError(newStructureForm, 'constructionKeyType'),
                      focus: focus.constructionKeyType
                    }"
                  >
                    Construction Key Type
                  </mat-label>

                <mat-select
                  [ngClass]="{
                    error: fieldHasError(newStructureForm, 'constructionKeyType'),
                    'focus-border': focus.constructionKeyType
                  }"
                  (focus)="focusOn('constructionKeyType')"
                  (focusout)="focusOn('constructionKeyType')"
                  matNativeControl
                  formControlName="constructionKeyType"
                  [(value)]="selectedConstructionKeyType"
                >
                  <mat-option *ngFor="let constructionKeyType of constructionTypes" [value]="constructionKeyType">
                    {{ constructionKeyType.description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <h6 class="section-header margin bottom">Hierarchy</h6>
          <!-- TMK Name -->
          <div class="row">
            <mat-form-field class="full-width" floatLabel="always" appearance="outline">
                <mat-label
                  for="tmkName"
                  [ngClass]="{
                    'error-message': fieldHasError(newStructureForm, 'tmkName'),
                    focus: focus.tmkName
                  }"
                >
                  TMK Name
                </mat-label>

              <div class="row">
                <input
                  [ngClass]="{
                    error: fieldHasError(newStructureForm, 'tmkName'),
                    'focus-border': focus.tmkName
                  }"
                  id="tmkName"
                  placeholder="Enter TMK Name"
                  formControlName="tmkName"
                  class="uppercase"
                  (focus)="focusOn('tmkName')"
                  (focusout)="focusOn('tmkName')"
                  autocomplete="no"
                  cdkFocusInitial
                  matInput
                  aria-describedby="tmkName errors"
                />

                <mat-icon
                  *ngIf="fieldHasError(newStructureForm, 'tmkName')"
                  class="error-icon"
                >warning
                </mat-icon>
              </div>

              <!-- Errors -->
              <div *ngFor="let validation of errorMessages.tmkName">
                <div
                  class="caption error-message margin lrg top"
                  *ngIf="fieldHasErrorMessages(newStructureForm, validation, 'tmkName')"
                  id="tmkNameErrors"
                >
                  {{ validation.message }}
                </div>
              </div>
            </mat-form-field>
          </div>
        </form>
      </div>
  </mat-card-content>

  <!-- Buttons -->
  <mat-card-actions>
    <div class="row flex-end">
      <button mat-stroked-button id="cancel" (click)="close()"> Cancel </button>
      <button
        mat-flat-button
        type="submit"
        (click)="createStructure()"
        [ngClass]="{'create-button': newStructureForm.valid}"
        class="margin left"
        [disabled]="!newStructureForm.valid"
        id="create"
      >
        Create Key System
      </button>
    </div>
  </mat-card-actions>
</mat-card>

